import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFilterJunctionInFormTable extends Layout {
    sourceMCFilterJunctionInForm: DataSource;
    tableMCFilterJunctionInForm: Table;
}
